import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Spring/AdditionAndSubtraction/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'AdditionAndSubtraction',
  field: 'Number',
  weeks: [4, 6],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/AdditionAndSubtraction/1AddByCountingOnWithin20" */ './1AddByCountingOnWithin20'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/AdditionAndSubtraction/2AddOnesUsingNumberBonds" */ './2AddOnesUsingNumberBonds'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/AdditionAndSubtraction/3FindAndMakeNumberBondsTo20" */ './3FindAndMakeNumberBondsTo20'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year1/Spring/AdditionAndSubtraction/4Doubles" */ './4Doubles')
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/AdditionAndSubtraction/5NearDoubles" */ './5NearDoubles'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/AdditionAndSubtraction/6SubtractOnesUsingNumberBonds" */ './6SubtractOnesUsingNumberBonds'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/AdditionAndSubtraction/7SubtractionCountingBack" */ './7SubtractionCountingBack'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/AdditionAndSubtraction/8SubtractionFindingTheDifference" */ './8SubtractionFindingTheDifference'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/AdditionAndSubtraction/9RelatedFacts" */ './9RelatedFacts'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/AdditionAndSubtraction/10MissingNumberProblems" */ './10MissingNumberProblems'
        )
    })
  ]
});
export default Block;
